import React, { Fragment } from 'react'
import { useViewProfile, userStore } from '../../store/userStore'
import { useNavigate } from 'react-router-dom'

const ApplicantViewButton = ({item, width}) => {

    const setApplicationId = useViewProfile((state) => state.setAppId)
    const navigate = useNavigate()
    
	const handleChange = async() => {
		await setApplicationId(item?.id)
		navigate('/applicantdetails')
  }

  return (
    <Fragment>
        <button 
        onClick={handleChange} 
        className='btn-customized'
        >
        View
        </button>
    </Fragment>
  )
}

export default ApplicantViewButton
